<template>
  <el-drawer
    :with-header="false"
    :wrapperClosable="false"
    size="1000px"
    class="create-tag-drawer"
    :visible.sync="drawerVisible"
    :append-to-body="true">
    <div class="drawer-wrapper">
      <div class="header flex flex-between">
        <span class="title" v-if="currentWay.type === 'view'"
          >创建{{ currentWay.name }}</span
        >
        <span class="title" v-else>{{ currentWay.name }}</span>
        <span @click="closeDrawer" class="hmicon icon-guanbi1 pointer"></span>
      </div>
      <hm-step
        @toNext="toNext"
        disabledJump
        :steps="steps"
        :step="currentStep"
        disabledNext
      ></hm-step>
      <div class="form-wrapper">
        <el-form
          label-width="150px"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          @submit.native.prevent >
          <!-- 第一页 -->
          <template v-if="currentStep === 1">
            <el-form-item label="标签名称" prop="tagName">
              <el-input
                type="text"
                style="width: 240px"
                :disabled="disabled"
                v-model="ruleForm.tagName"
                @input="getPinyin"
                maxlength="20"
                placeholder="请输入标签中文名称"
                size="small"
              ></el-input>
            </el-form-item>
            <el-form-item label="标签ID" prop="tagKey">
              <el-input
                type="text"
                style="width: 240px"
                maxlength="20"
                :disabled="disabled"
                v-model="ruleForm.tagKey"
                placeholder="请输入标签ID"
                size="small"
              >
                <template slot="prepend">pingtai_</template>
              </el-input>
            </el-form-item>
            <el-form-item label="渠道" prop="tenantId">
              <el-select
                size="small"
                placeholder="请选择渠道"
                :disabled="disabled"
                v-model="ruleForm.tenantId"
                class="mr10"
                clearable
                filterable
                remote
                :remote-method="remoteMethod"
              >
                <el-option
                  v-for="(v, i) in storeCodeList"
                  :key="i"
                  :label="v.storeName"
                  :value="v.storeCode"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="标签分类" prop="tagCatArray">
              <el-cascader
                ref="cascader"
                :disabled="disabled"
                v-model="ruleForm.tagCatArray"
                :props="catProps"
                :options="catOptions"
                :show-all-levels="false"
                size="small"
              ></el-cascader>
              <el-button
                class="newAdded"
                v-if="draggableShow"
                @click="openCation"
                type="primary"
                size="small"
                >新建分类</el-button
              >
            </el-form-item>
            <el-form-item label="更新周期" prop="tagUpdateTimeType">
              <el-select
                style="width: 100px"
                size="small"
                placeholder="请选择更新周期"
                :disabled="disabled"
                v-model="ruleForm.tagUpdateTimeType"
                class="mr10"
                filterable
              >
                <el-option
                  v-for="(v, i) in updateCycleList"
                  :key="i"
                  :label="v.name"
                  :value="v.value"
                ></el-option>
              </el-select>
              <el-date-picker
                :disabled="disabled"
                v-model="ruleForm.tagUpdateTime"
                size="small"
                type="daterange"
                :clearable="false"
                :picker-options="pickerOptions1"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="数据源" prop="datasourceId">
              <el-select
                size="small"
                placeholder="请选择数据源"
                :disabled="disabled"
                v-model="ruleForm.datasourceId"
                class="mr10"
                filterable
              >
                <el-option
                  v-for="(v, i) in datasoureList"
                  :key="i"
                  :label="v.dc"
                  :value="v.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="有效期" prop="forever">
              <el-radio-group v-model="ruleForm.forever">
                <el-radio label="yes">长期有效</el-radio>
                <el-radio label="no">非长期有效</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="商户客户分群展示" prop="showGroup">
              <el-radio-group v-model="ruleForm.showGroup">
                <el-radio label="yes">展示</el-radio>
                <el-radio label="no">不展示</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="客户分群展示形式" prop="showTypeList">
              <el-checkbox-group
                v-model="showTypeList"
                @change="showTypeChange"
              >
                <el-checkbox
                  v-for="(v, i) in groupList"
                  :label="v.value"
                  :key="i"
                  >{{ v.name }}</el-checkbox
                >
              </el-checkbox-group>
            </el-form-item>
            <el-form-item label="标签含义" prop="tagRemark">
              <el-input
                type="textarea"
                :autosize="false"
                rows="5"
                style="width: 380px"
                show-word-limit
                maxlength="100"
                :disabled="disabled"
                v-model="ruleForm.tagRemark"
                placeholder="请输入备注"
              />
            </el-form-item>
          </template>
          <!-- 第二页 -->
          <template v-else>
            <!-- 多属性标签创建 -->
            <template v-if="currentWay.wayName === 'multiAttr'">
              <div>
                <span
                  >在全部{{
                    queryType === "user" ? "用户" : "商品"
                  }}中，将满足以下条件的用户分为
                  {{ tagRunInfo.length }} 个标签值</span>
                <el-button
                  type="text"
                  class="link"
                  size="small"
                  @click="showExample"
                  >查看示例</el-button
                >
              </div>
              <div class="tips">
                系统会按照以下自定义标签值的顺序进行{{
                  queryType === "user" ? "用户" : "商品"
                }}匹配，同一{{
                  queryType === "user" ? "用户" : "商品"
                }}会被优先匹配在顺序靠前的标签值中
              </div>
              <div class="tag-list">
                <!-- 添加标签 -->
                <div class="list-header flex flex-wrap">
                  <div class="flex mb10 mr20">
                    <el-input
                      class="input-new-tag"
                      v-if="inputVisible"
                      :disabled="disabled"
                      v-model="inputValue"
                      ref="saveTagInput"
                      maxlength="10"
                      size="small"
                      show-word-limit
                      @keyup.enter.native="handleInputConfirm"
                      @blur="handleInputConfirm"
                    >
                    </el-input>
                    <el-button
                      v-else
                      class="button-new-tag"
                      size="small"
                      @click="showInput"
                      :disabled="disabled"
                      >+添加标签值</el-button
                    >
                  </div>
                  <div
                    class="tag pointer flex item-center mr20 mb10"
                    :class="{
                      active: activeTagTab === i,
                      primary: activeTagTab !== i
                    }"
                    @click="switchTagTab(i)"
                    v-for="(v, i) in tagRunInfo"
                    :key="i"
                  >
                    <span class="tag-name">{{ v.tagName }}</span>
                    <span
                      @click="handleClose(i)"
                      v-if="!disabled"
                      class="hmicon icon-guanbi1 close"
                    ></span>
                  </div>
                </div>
                <template v-for="(v, i) in tagRunInfo">
                  <div
                    class="list-row mt20"
                    :key="'i' + i"
                    v-if="activeTagTab === i">
                    <div class="tag-name">
                      <el-input
                        type="text"
                        placeholder="请输入标签值"
                        :disabled="disabled"
                        v-model="v.tagName"
                        maxlength="10"
                        style="width: 100%"
                        size="small"
                        show-word-limit
                      ></el-input>
                    </div>
                    <div class="mt20">
                      <el-input
                        type="textarea"
                        :disabled="disabled"
                        v-model="v.comments"
                        style="width: 100%"
                        placeholder="请输入标签描述"
                        rows="4"
                        v-if="v.tagName"
                        maxlength="100"
                        show-word-limit
                      ></el-input>
                    </div>
                    <div
                      class="mt20 flex m-size item-center"
                      v-if="
                        currentWay.wayName !== 'sql' &&
                          ruleForm.forever !== 'yes'">
                      失效时间：
                      <el-select
                        v-model="v.invalidId"
                        size="small"
                        style="width: 180px"
                        class="mr10"
                        placeholder="请选择失效时间类型"
                      >
                        <el-option
                          v-for="(type, tI) in invalidBaseList"
                          :key="tI"
                          :label="type.name"
                          :value="type.id"
                        ></el-option>
                      </el-select>
                      <div>
                        <span class="mr10">未来</span>
                        <el-input
                          style="width: 80px"
                          size="small"
                          class="mr10"
                          v-model="v.invalidDate"
                        ></el-input
                        >天之后
                      </div>
                    </div>
                    <div class="rule-list flex">
                      <div class="relation-wrapper" @click="changeRelation(v)">
                        <span
                          class="relation pointer"
                          v-if="v.relation === 'and'"
                          >且</span
                        >
                        <span class="relation pointer" v-else>或</span>
                      </div>
                      <ul class="flex-1">
                        <li
                          class="rule-item"
                          v-for="(item, index) in v.rules"
                          :key="index"
                          v-if="!((item.type == 'user_behavior' || item.type == 'user_behavior_order') && queryType == 'goods') "
                          :class="{ collapse: item.collapse }">
                          <!-- 第一层标题 -->
                          <div class="item-header flex flex-between">
                            <div class="flex flex-between item-center">
                              <div
                                class="collapse-wrapper flex item-center pointer"
                                @click="collapseItem(item, v)">
                                <span
                                  class="hmicon icon-zhankai"
                                  v-if="item.collapse" ></span>
                                <span v-else class="hmicon icon-zhedie"></span>
                              </div>
                              <span class="item-title">{{ item.name }}</span>
                            </div>
                            <div
                              v-if="!disabled"
                              class="add-wrapper flex flex-center"
                            >
                              <span
                                class="hmicon icon-hao pointer"
                                @click="addChild(item)"
                              ></span>
                            </div>
                          </div>
                          <!-- 第二层条件 -->
                          <div class="child-condition" v-if="item.rules.length">
                            <div
                              class="relation-wrapper"
                              @click="changeRelation(item)" >
                              <span
                                class="relation pointer"
                                v-if="item.relation === 'and'"
                                >且</span >
                              <span class="relation pointer" v-else>或</span>
                            </div>
                            <div
                              class="item-header"
                              v-for="(rule, ruleIndex) in item.rules"
                              :key="ruleIndex" >
                              <div class="flex flex-between">
                                <div class="conditions flex-1">
                                  <div class="flex flex-between">
                                    <div class="index-wrapper">
                                      {{ index2Letter(ruleIndex) }}
                                    </div>
                                    <div class="flex-1">
                                      <!-- 属性满足 -->
                                      <template
                                        v-if="item.type === 'user_attr'">
                                        <el-select
                                          :disabled="disabled"
                                          v-model="rule.userAttr"
                                          size="small"
                                          value-key="id"
                                          style="width: 140px"
                                          @change="getUserAttr(rule)"
                                          class="mr10"
                                          placeholder="请选择属性">
                                          <el-option
                                            v-for="(attr, aI) in userAttrList"
                                            :key="aI"
                                            :label="
                                              attr.ruleName +
                                                '(' +
                                                attr.calcMode +
                                                ')'"
                                            :value="attr"
                                          ></el-option>
                                        </el-select>
                                        <el-cascader
                                          size="small"
                                          :disabled="disabled"
                                          v-model="rule.symbol"
                                          style="width: 140px"
                                          class="mr10 tag-cascader"
                                          :options="rule.options"
                                          :show-all-levels="false"
                                        ></el-cascader>

                                        <el-select
                                          v-if="
                                            rule &&
                                              rule.userAttr &&
                                              rule.userAttr.allAList "
                                          clearable
                                          v-model="rule.value"
                                          size="small"
                                          class="mr10 flex-1"
                                          placeholder="请选择商品品牌">
                                          <el-option
                                            :label="v.brandName"
                                            :value="v.brandId"
                                            v-for="(v,
                                            i) in allBrandList.records"
                                            :key="i"
                                          ></el-option>
                                        </el-select>
                                        <!-- 微店分类 allBList 判断是否是下拉菜单 -->
                                        <el-cascader
                                          v-if="
                                            rule &&
                                              rule.userAttr &&
                                              rule.userAttr.allBList
                                          "
                                          v-model="rule.value"
                                          :show-all-levels="false"
                                          size="small"
                                          class="mr10 flex-1"
                                          :props="categoryProp"
                                          clearable
                                          placeholder="请选择微店商品分类"
                                        ></el-cascader>

                                        <!-- 非日期类型 -->
                                        <el-input
                                          v-if="
                                            rule.userAttr &&
                                              (rule.userAttr.calcMode ===
                                                'string' ||
                                                rule.userAttr.calcMode ===
                                                  'int') &&
                                              rule.symbol &&
                                              rule.symbol[0] !==
                                                'IS NOT NULL' &&
                                              rule.symbol[0] !== 'NULL' &&
                                              !rule.userAttr.allAList &&
                                              !rule.userAttr.allBList
                                          "
                                          size="small"
                                          style="width: 140px"
                                          :disabled="disabled"
                                          v-model="rule.value"
                                          placeholder="请输入值"
                                        ></el-input>

                                        <!-- 日期类型 -->
                                        <template
                                          v-if="rule.symbol && rule.symbol[0]"
                                        >
                                          <!-- 绝对时间 -->
                                          <template
                                            v-if="
                                              rule.symbol[0] === 'ABSOLUTE TIME'
                                            "
                                          >
                                            <template
                                              v-if="
                                                rule.symbol[1] !== 'BETWEEN'
                                              "
                                            >
                                              <el-date-picker
                                                :disabled="disabled"
                                                v-model="rule.value"
                                                type="date"
                                                size="small"
                                                class="tag-datepicker mr10"
                                                style="width: 140px"
                                                value-format="yyyy-MM-dd"
                                                format="yyyy-MM-dd"
                                                placeholder="选择日期"
                                              >
                                              </el-date-picker>
                                            </template>
                                            <template v-else>
                                              <div class="mt10">
                                                <el-date-picker
                                                  :disabled="disabled"
                                                  v-model="rule.value"
                                                  type="datetimerange"
                                                  class="mr10"
                                                  size="small"
                                                  value-format="yyyy-MM-dd HH:mm:ss"
                                                  format="yyyy-MM-dd HH:mm:ss"
                                                  range-separator="至"
                                                  start-placeholder="开始日期"
                                                  end-placeholder="结束日期"
                                                >
                                                </el-date-picker>
                                              </div>
                                            </template>
                                          </template>
                                          <!-- 相对当前时间 -->
                                          <template
                                            v-if="
                                              rule.symbol[0] === 'RELATIVE TIME'
                                            "
                                          >
                                            <div class="mt10">
                                              <span class="mr10 m-size"
                                                >在</span
                                              >
                                              <el-select
                                                size="small"
                                                style="width: 120px"
                                                class="mr10"
                                                :disabled="disabled"
                                                v-model="rule.relativeDateType"
                                              >
                                                <el-option
                                                  label="过去"
                                                  value="PAST TIMES"
                                                ></el-option>
                                                <el-option
                                                  label="未来"
                                                  value="FUTURE"
                                                ></el-option>
                                              </el-select>
                                              <el-input
                                                size="small"
                                                style="width: 120px"
                                                class="mr10"
                                                :disabled="disabled"
                                                v-model="rule.value"
                                                type="number"
                                                placeholder="天数"
                                              ></el-input>
                                              <span class="mr10 m-size"
                                                >天</span
                                              >
                                              <el-select
                                                size="small"
                                                style="width: 120px"
                                                :disabled="disabled"
                                                v-model="rule.relativeDateRange"
                                              >
                                                <el-option
                                                  label="之内"
                                                  value="WITHIN"
                                                ></el-option>
                                                <el-option
                                                  label="之前"
                                                  v-if="
                                                    rule.relativeDateType ===
                                                      'PAST TIMES'
                                                  "
                                                  value="BEFORE"
                                                ></el-option>
                                                <el-option
                                                  v-else
                                                  label="之后"
                                                  value="AFTER"
                                                ></el-option>
                                              </el-select>
                                            </div>
                                          </template>
                                          <!-- 相对当前时间区间 -->
                                          <template
                                            v-if="
                                              rule.symbol[0] ===
                                                'RELATIVE BETWEEN TIME'
                                            "
                                          >
                                            <div
                                              class="mt10 relative-between-time"
                                            >
                                              <span class="mr10 m-size"
                                                >在</span
                                              >
                                              <el-select
                                                size="small"
                                                style="width: 120px"
                                                class="mr10"
                                                :disabled="disabled"
                                                v-model="rule.relativeDateType"
                                              >
                                                <el-option
                                                  label="过去"
                                                  value="PAST TIMES"
                                                ></el-option>
                                                <el-option
                                                  label="未来"
                                                  value="FUTURE"
                                                ></el-option>
                                              </el-select>
                                              <el-input
                                                class="mr10"
                                                size="small"
                                                type="number"
                                                :disabled="disabled"
                                                v-model="rule.betweenStartDay"
                                                placeholder="天数"
                                                style="width: 100px"
                                              ></el-input>
                                              <span class="mr10"
                                                >天至<template
                                                  v-if="
                                                    rule.relativeDateType ===
                                                      'PAST TIMES'
                                                  "
                                                >
                                                  过去
                                                </template>
                                                <template v-else>未来</template>
                                              </span>
                                              <el-input
                                                class="mr10"
                                                size="small"
                                                type="number"
                                                :disabled="disabled"
                                                v-model="rule.betweenEndDay"
                                                placeholder="天数"
                                                style="width: 100px"
                                              ></el-input>
                                              天之内
                                            </div>
                                          </template>
                                        </template>
                                      </template>
                                      <!-- 行为满足 -->
                                      <template
                                        v-if="item.type == 'user_behavior'">
                                        <div class="flex flex-wrap">
                                          <el-select
                                            size="small"
                                            style="width: 100px"
                                            class="mr10"
                                            @change="changeTimeType(rule)"
                                            :disabled="disabled"
                                            v-model="rule.timeType">
                                            <el-option
                                              label="绝对时间"
                                              value="absolute"
                                            ></el-option>
                                            <el-option
                                              label="相对时间"
                                              value="relative"
                                            ></el-option>
                                          </el-select>
                                          <el-date-picker
                                            v-if="rule.timeType === 'absolute'"
                                            :disabled="disabled"
                                            v-model="rule.behaviorDate"
                                            type="daterange"
                                            size="small"
                                            class="mr10"
                                            value-format="yyyy-MM-dd"
                                            format="yyyy-MM-dd"
                                            :picker-options="pickerOptions2"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                          >
                                          </el-date-picker>
                                          <div class="m-size" v-else>
                                            <span class="mr10">过去</span>
                                            <el-input
                                              size="small"
                                              type="number"
                                              style="width: 60px"
                                              class="mr10"
                                              :disabled="disabled"
                                              v-model="rule.behaviorStartDate"
                                            ></el-input>
                                            <span class="mr10">天至过去</span>
                                            <el-input
                                              type="number"
                                              size="small"
                                              style="width: 60px"
                                              class="mr10"
                                              :disabled="disabled"
                                              v-model="
                                                rule.behaviorStartEndDate
                                              "
                                            ></el-input>
                                            <span class="mr10">天</span>
                                          </div>
                                          <el-select
                                            size="small"
                                            style="width: 90px"
                                            class="mr10"
                                            :disabled="disabled"
                                            v-model="rule.isDoing">
                                            <el-option
                                              label="做过"
                                              value="YES"
                                            ></el-option>
                                            <!-- <el-option
                                              label="未做过"
                                              value="NO"
                                            ></el-option> -->
                                          </el-select>
                                          <el-select
                                            :disabled="disabled"
                                            v-model="rule.behavior"
                                            size="small"
                                            value-key="id"
                                            style="width: 140px"
                                            @change="getUserBehaver(rule)"
                                            class="mr10"
                                            placeholder="请选择属性">
                                            <el-option
                                              v-for="(behavior,
                                              bI) in userBehaviorList"
                                              :key="bI"
                                              :label="
                                                behavior.ruleName +
                                                  '(' +
                                                  behavior.calcMode +
                                                  ')'
                                              "
                                              :value="behavior"
                                            ></el-option>
                                          </el-select>
                                          <el-button
                                            @click="addFilterCondition(rule)"
                                            size="small"
                                            type="text"
                                            class="pray"
                                            v-if="!disabled && rule.isDoing != 'NO'">
                                            + 添加筛选
                                          </el-button>
                                        </div>
                                        <div
                                          class="mt10 mb10 flex subrule-container"
                                          v-if="rule.subRule.length">
                                          <span class="m-size type">并且满足</span>
                                          <!-- 子条件 -->
                                          <div class="subrule-wrapper" v-if="rule.isDoing=='YES'">
                                            <div
                                              class="relation-wrapper"
                                              @click="changeSubruleRelation(rule)">
                                              <span
                                                class="relation pointer"
                                                v-if="
                                                  rule.subRuleRelation === 'and'
                                                ">且</span >
                                              <span
                                                class="relation pointer"
                                                v-else>或</span
                                              >
                                            </div>
                                            <!-- 二级用户行为修改 -->
                                            <div
                                              v-for="(subRule,
                                              subI) in rule.subRule"
                                              class="sub-rule"
                                              :key="subI" >
                                              <el-select
                                                :disabled="disabled"
                                                v-model="subRule.userAttr"
                                                size="small"
                                                value-key="id"
                                                style="width: 140px"
                                                @change="getSubRuleUserAttr(subRule)"
                                                class="mr10"
                                                placeholder="请选择属性">
                                                <el-option
                                                  v-for="(attr,
                                                  aI) in userGoodsAttr"
                                                  :key="aI"
                                                  :label="
                                                    attr.ruleName +
                                                      '(' +
                                                      attr.calcMode +
                                                      ')'" :value="attr">
                                                </el-option>
                                              </el-select>
                                              <el-cascader
                                                size="small"
                                                :disabled="disabled"
                                                v-model="subRule.symbol"
                                                style="width: 140px"
                                                class="mr10 tag-cascader"
                                                :options="subRule.options"
                                                :show-all-levels="false" >
                                              </el-cascader>
                                              <!-- 商品品牌 allAList-->
                                              <el-select
                                                v-if="
                                                  subRule &&
                                                    subRule.userAttr &&
                                                    subRule.userAttr.allAList"
                                                clearable
                                                v-model="subRule.value"
                                                size="small"
                                                class="mr10 flex-1"
                                                placeholder="请选择商品品牌">
                                                <el-option
                                                  :label="v.brandName"
                                                  :value="v.brandId"
                                                  v-for="(v,
                                                  i) in allBrandList.records"
                                                  :key="i"
                                                ></el-option>
                                              </el-select>
                                              <!-- 微店分类 allBList 判断是否是下拉菜单 -->
                                              <el-cascader
                                                v-if="
                                                  subRule &&
                                                    subRule.userAttr &&
                                                    subRule.userAttr.allBList"
                                                v-model="subRule.value"
                                                :show-all-levels="false"
                                                size="small"
                                                class="mr10 flex-1"
                                                :props="categoryProp"
                                                clearable
                                                placeholder="请选择微店商品分类"
                                              ></el-cascader>
                                              <!-- 非日期类型 -->
                                              <el-input
                                                v-if="
                                                  subRule.userAttr &&
                                                    (subRule.userAttr
                                                      .calcMode === 'string' ||
                                                      subRule.userAttr
                                                        .calcMode === 'int') &&
                                                    subRule.symbol &&
                                                    subRule.symbol[0] !==
                                                      'IS NOT NULL' &&
                                                    subRule.symbol[0] !==
                                                      'NULL' &&
                                                    (!subRule.userAttr
                                                      .allAList ||
                                                      !subRule.userAttr
                                                        .allBList)
                                                "
                                                size="small"
                                                style="width: 140px"
                                                class="mr10"
                                                :disabled="disabled"
                                                v-model="subRule.value"
                                                placeholder="请输入值"
                                              >
                                              </el-input>

                                              <!-- 日期类型 -->
                                              <template
                                                v-if="
                                                  subRule.symbol &&
                                                    subRule.symbol[0]
                                                " >
                                                <!-- 绝对时间 -->
                                                <template
                                                  v-if="
                                                    subRule.symbol[0] ===
                                                      'ABSOLUTE TIME'">
                                                  <template
                                                    v-if="
                                                      subRule.symbol[1] !==
                                                        'BETWEEN'">
                                                    <el-date-picker
                                                      :disabled="disabled"
                                                      v-model="subRule.value"
                                                      type="date"
                                                      size="small"
                                                      class="tag-datepicker"
                                                      style="width: 140px"
                                                      value-format="yyyy-MM-dd"
                                                      format="yyyy-MM-dd"
                                                      placeholder="选择日期">
                                                    </el-date-picker>
                                                  </template>
                                                  <template v-else>
                                                    <div class="mt10">
                                                      <el-date-picker
                                                        :disabled="disabled"
                                                        v-model="subRule.value"
                                                        type="datetimerange"
                                                        class="mr10"
                                                        size="small"
                                                        value-format="yyyy-MM-dd HH:mm:ss"
                                                        format="yyyy-MM-dd HH:mm:ss"
                                                        range-separator="至"
                                                        start-placeholder="开始日期"
                                                        end-placeholder="结束日期">
                                                      </el-date-picker>
                                                    </div>
                                                  </template>
                                                </template>
                                                <!-- 相对当前时间 -->
                                                <template
                                                  v-if="
                                                    subRule.symbol[0] ===
                                                      'RELATIVE TIME'">
                                                  <div class="mt10">
                                                    <span class="mr10 m-size"
                                                      >在</span
                                                    >
                                                    <el-select
                                                      size="small"
                                                      style="width: 120px"
                                                      class="mr10"
                                                      :disabled="disabled"
                                                      v-model="
                                                        subRule.relativeDateType
                                                      "
                                                    >
                                                      <el-option
                                                        label="过去"
                                                        value="PAST TIMES"
                                                      ></el-option>
                                                      <el-option
                                                        label="未来"
                                                        value="FUTURE"
                                                      ></el-option>
                                                    </el-select>
                                                    <el-input
                                                      size="small"
                                                      style="width: 120px"
                                                      class="mr10"
                                                      :disabled="disabled"
                                                      v-model="subRule.value"
                                                      type="number"
                                                      placeholder="天数"
                                                    ></el-input>
                                                    <span class="mr10 m-size"
                                                      >天</span
                                                    >
                                                    <el-select
                                                      size="small"
                                                      style="width: 120px"
                                                      :disabled="disabled"
                                                      v-model="
                                                        subRule.relativeDateRange
                                                      "
                                                    >
                                                      <el-option
                                                        label="之内"
                                                        value="WITHIN"
                                                      ></el-option>
                                                      <el-option
                                                        label="之前"
                                                        v-if="
                                                          subRule.relativeDateType ===
                                                            'PAST TIMES'
                                                        "
                                                        value="BEFORE"
                                                      ></el-option>
                                                      <el-option
                                                        v-else
                                                        label="之后"
                                                        value="AFTER"
                                                      ></el-option>
                                                    </el-select>
                                                  </div>
                                                </template>
                                                <!-- 相对当前时间区间 -->
                                                <template
                                                  v-if="
                                                    subRule.symbol[0] ===
                                                      'RELATIVE BETWEEN TIME' ">
                                                  <div
                                                    class="mt10 relative-between-time">
                                                    <span class="mr10 m-size">在</span>
                                                    <el-select
                                                      size="small"
                                                      style="width: 120px"
                                                      class="mr10"
                                                      :disabled="disabled"
                                                      v-model="
                                                        subRule.relativeDateType
                                                      "
                                                    >
                                                      <el-option
                                                        label="过去"
                                                        value="PAST TIMES"
                                                      ></el-option>
                                                      <el-option
                                                        label="未来"
                                                        value="FUTURE"
                                                      ></el-option>
                                                    </el-select>
                                                    <el-input
                                                      class="mr10"
                                                      size="small"
                                                      type="number"
                                                      :disabled="disabled"
                                                      v-model="
                                                        subRule.betweenStartDay
                                                      "
                                                      placeholder="天数"
                                                      style="width: 100px"
                                                    ></el-input>
                                                    <span class="mr10"
                                                      >天至<template
                                                        v-if="
                                                          subRule.relativeDateType ===
                                                            'PAST TIMES'
                                                        "
                                                      >
                                                        过去
                                                      </template>
                                                      <template v-else
                                                        >未来</template
                                                      >
                                                    </span>
                                                    <el-input
                                                      class="mr10"
                                                      size="small"
                                                      type="number"
                                                      :disabled="disabled"
                                                      v-model="
                                                        subRule.betweenEndDay
                                                      "
                                                      placeholder="天数"
                                                      style="width: 100px"
                                                    ></el-input>
                                                    天之内
                                                  </div>
                                                </template>
                                              </template>
                                              <el-button
                                                type="text"
                                                size="small"
                                                class="gray"
                                                @click="removeSubRule(rule, subI)
                                                " >删除
                                              </el-button>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          class="mr10 mt10"
                                          v-if="rule.isDoing === 'YES'">
                                          <el-select
                                            :disabled="disabled"
                                            v-model="rule.behaviorType"
                                            size="small"
                                            value-key="id"
                                            style="width: 140px"
                                            class="mr10"
                                            placeholder="请选择行为类型">
                                            <el-option
                                              v-for="(behaviorType,
                                              btI) in behaviorTypeList"
                                              :key="btI"
                                              :label="behaviorType.name"
                                              :value="behaviorType.value"
                                            ></el-option>
                                          </el-select>
                                          <!-- 符号 -->
                                          <el-select
                                            :disabled="disabled"
                                            v-model="rule.behaviorSymol"
                                            size="small"
                                            value-key="id"
                                            style="width: 100px"
                                            class="mr10"
                                            placeholder="符号"
                                          >
                                            <el-option
                                              v-for="(behaviorSymol,
                                              bsI) in behaviorSymbolList"
                                              :key="bsI"
                                              :label="behaviorSymol.label"
                                              :value="behaviorSymol.value"
                                            ></el-option>
                                          </el-select>
                                          <!-- 非区间 -->
                                          <template
                                            v-if="
                                              rule.behaviorSymol !== 'BETWEEN'
                                            "
                                          >
                                            <el-input
                                              class="mr10"
                                              :disabled="disabled"
                                              v-model="rule.times"
                                              size="small"
                                              type="number"
                                              style="width: 80px"
                                              placeholder="次数"
                                            ></el-input>
                                            <span class="m-size">次</span>
                                          </template>
                                          <template v-else>
                                            <el-input
                                              class="mr10"
                                              :disabled="disabled"
                                              v-model="rule.lowerTimes"
                                              size="small"
                                              type="number"
                                              style="width: 60px"
                                              placeholder="次数"
                                            ></el-input>
                                            <span class="m-size mr10">至</span>
                                            <el-input
                                              class="mr10"
                                              :disabled="disabled"
                                              v-model="rule.upperTimes"
                                              size="small"
                                              type="number"
                                              style="width: 60px"
                                              placeholder="次数"
                                            ></el-input>
                                            <span class="m-size">次</span>
                                          </template>
                                        </div>
                                      </template>
                                      <!-- 行为序列 -->
                                      <template
                                        v-if="
                                          item.type == 'user_behavior_order' && queryType != 'goods' ">
                                        <div class="flex flex-wrap item-center">
                                          <el-select
                                            size="small"
                                            style="width: 100px"
                                            @change="changeTimeType(rule)"
                                            class="mr10"
                                            :disabled="disabled"
                                            v-model="rule.timeType">
                                            <el-option
                                              label="绝对时间"
                                              value="absolute"
                                            ></el-option>
                                            <el-option
                                              label="相对时间"
                                              value="relative"
                                            ></el-option>
                                          </el-select>
                                          <el-date-picker
                                            v-if="rule.timeType === 'absolute'"
                                            :disabled="disabled"
                                            v-model="rule.behaviorDate"
                                            type="daterange"
                                            size="small"
                                            class="mr10"
                                            value-format="yyyy-MM-dd"
                                            format="yyyy-MM-dd"
                                            :picker-options="pickerOptions2"
                                            range-separator="至"
                                            start-placeholder="开始日期"
                                            end-placeholder="结束日期"
                                          >
                                          </el-date-picker>
                                          <div class="m-size" v-else>
                                            <span class="mr10">过去</span>
                                            <el-input
                                              size="small"
                                              type="number"
                                              style="width: 60px"
                                              class="mr10"
                                              :disabled="disabled"
                                              v-model="rule.behaviorStartDate"
                                            ></el-input>
                                            <span class="mr10">天至过去</span>
                                            <el-input
                                              type="number"
                                              size="small"
                                              style="width: 60px"
                                              class="mr10"
                                              :disabled="disabled"
                                              v-model="
                                                rule.behaviorStartEndDate
                                              "
                                            ></el-input>
                                            <span class="mr10">天</span>
                                          </div>
                                          <span class="m-size">依次做过</span>
                                        </div>
                                        <div
                                          v-for="(behavior,
                                          behI) in rule.behaviorSteps"
                                          :key="behI"
                                          class="mt10"
                                        >
                                          <div class="flex flex-between">
                                            <div class="index-wrapper child flex flex-center item-center">
                                              {{ index2Letter(ruleIndex)}}{{ behI + 1 }}
                                            </div>
                                            <div
                                              class="flex flex-1 flex-between" >
                                              <div>
                                                <el-select
                                                  :disabled="disabled"
                                                  v-model="behavior.behavior"
                                                  size="small"
                                                  value-key="id"
                                                  style="width: 140px"
                                                  class="mr10"
                                                  placeholder="请选择用户行为">
                                                  <el-option
                                                    v-for="(behavior,
                                                    bI) in userBehaviorList"
                                                    :key="bI"
                                                    :label="
                                                      behavior.ruleName +
                                                        '(' +
                                                        behavior.calcMode +
                                                        ')'
                                                    "
                                                    :value="behavior"
                                                  ></el-option>
                                                </el-select>
                                              </div>
                                              <div class="">
                                                <el-button
                                                  size="small"
                                                  type="text"
                                                  @click="
                                                    removeEvent(rule, behI)
                                                  "
                                                  v-if="!disabled"
                                                  class="hmicon icon-guanbi1"
                                                ></el-button>
                                              </div>
                                            </div>
                                          </div>

                                          <div
                                            class="mt10 mb10 flex subrule-container"
                                            v-if="behavior.subRule.length"
                                          >
                                            <span class="m-size type"
                                              >并且满足</span
                                            >
                                            <!-- 子条件 -->
                                            <div class="subrule-wrapper">
                                              <div
                                                class="relation-wrapper"
                                                @click="
                                                  changeSubruleRelation(
                                                    behavior
                                                  )
                                                "
                                              >
                                                <span
                                                  class="relation pointer"
                                                  v-if="
                                                    behavior.subRuleRelation ===
                                                      'and'
                                                  "
                                                  >且</span>
                                                <span
                                                  class="relation pointer"
                                                  v-else
                                                  >或</span>
                                              </div>
                                              <div
                                                v-for="(subRule,
                                                subI) in behavior.subRule"
                                                class="sub-rule"
                                                :key="subI">
                                                <el-select
                                                  :disabled="disabled"
                                                  v-model="subRule.userAttr"
                                                  size="small"
                                                  value-key="id"
                                                  style="width: 140px"
                                                  @change="getSubRuleUserAttr(subRule)"
                                                  class="mr10"
                                                  placeholder="请选择属性">
                                                  <el-option
                                                    v-for="(attr,
                                                    aI) in userAttrList"
                                                    :key="aI"
                                                    :label="
                                                      attr.ruleName +
                                                        '(' +
                                                        attr.calcMode +
                                                        ')'"
                                                    :value="attr"
                                                  ></el-option>
                                                </el-select>
                                                <el-cascader
                                                  size="small"
                                                  :disabled="disabled"
                                                  v-model="subRule.symbol"
                                                  style="width: 140px"
                                                  class="mr10 tag-cascader"
                                                  :options="subRule.options"
                                                  :show-all-levels="false"
                                                ></el-cascader>
                                                <!-- 非日期类型 -->
                                                <el-input
                                                  v-if="
                                                    subRule.userAttr &&
                                                      (subRule.userAttr
                                                        .calcMode ===
                                                        'string' ||
                                                        subRule.userAttr
                                                          .calcMode ===
                                                          'int') &&
                                                      subRule.symbol &&
                                                      subRule.symbol[0] !==
                                                        'IS NOT NULL' &&
                                                      subRule.symbol[0] !==
                                                        'NULL'
                                                  "
                                                  size="small"
                                                  style="width: 140px"
                                                  class="mr10"
                                                  :disabled="disabled"
                                                  v-model="subRule.value"
                                                  placeholder="请输入值"
                                                ></el-input>
                                                <!-- 日期类型 -->
                                                <template
                                                  v-if="
                                                    subRule.symbol &&
                                                      subRule.symbol[0] ">
                                                  <!-- 绝对时间 -->
                                                  <template
                                                    v-if="
                                                      subRule.symbol[0] ===
                                                        'ABSOLUTE TIME'
                                                    "
                                                  >
                                                    <template
                                                      v-if="
                                                        subRule.symbol[1] !==
                                                          'BETWEEN'
                                                      "
                                                    >
                                                      <el-date-picker
                                                        :disabled="disabled"
                                                        v-model="subRule.value"
                                                        type="date"
                                                        size="small"
                                                        class="tag-datepicker mr10"
                                                        style="width: 140px"
                                                        value-format="yyyy-MM-dd"
                                                        format="yyyy-MM-dd"
                                                        placeholder="选择日期"
                                                      >
                                                      </el-date-picker>
                                                    </template>
                                                    <template v-else>
                                                      <div class="mt10">
                                                        <el-date-picker
                                                          :disabled="disabled"
                                                          v-model="
                                                            subRule.value
                                                          "
                                                          type="datetimerange"
                                                          class="mr10"
                                                          size="small"
                                                          value-format="yyyy-MM-dd HH:mm:ss"
                                                          format="yyyy-MM-dd HH:mm:ss"
                                                          range-separator="至"
                                                          start-placeholder="开始日期"
                                                          end-placeholder="结束日期"
                                                        >
                                                        </el-date-picker>
                                                      </div>
                                                    </template>
                                                  </template>
                                                  <!-- 相对当前时间 -->
                                                  <template
                                                    v-if="
                                                      subRule.symbol[0] ===
                                                        'RELATIVE TIME'
                                                    "
                                                  >
                                                    <div class="mt10">
                                                      <span class="mr10 m-size"
                                                        >在</span
                                                      >
                                                      <el-select
                                                        size="small"
                                                        style="width: 120px"
                                                        class="mr10"
                                                        :disabled="disabled"
                                                        v-model="
                                                          subRule.relativeDateType
                                                        "
                                                      >
                                                        <el-option
                                                          label="过去"
                                                          value="PAST TIMES"
                                                        ></el-option>
                                                        <el-option
                                                          label="未来"
                                                          value="FUTURE"
                                                        ></el-option>
                                                      </el-select>
                                                      <el-input
                                                        size="small"
                                                        style="width: 120px"
                                                        class="mr10"
                                                        :disabled="disabled"
                                                        v-model="subRule.value"
                                                        type="number"
                                                        placeholder="天数"
                                                      ></el-input>
                                                      <span class="mr10 m-size"
                                                        >天</span
                                                      >
                                                      <el-select
                                                        size="small"
                                                        style="width: 120px"
                                                        :disabled="disabled"
                                                        v-model="
                                                          subRule.relativeDateRange
                                                        "
                                                      >
                                                        <el-option
                                                          label="之内"
                                                          value="WITHIN"
                                                        ></el-option>
                                                        <el-option
                                                          label="之前"
                                                          v-if="
                                                            subRule.relativeDateType ===
                                                              'PAST TIMES'
                                                          "
                                                          value="BEFORE"
                                                        ></el-option>
                                                        <el-option
                                                          v-else
                                                          label="之后"
                                                          value="AFTER"
                                                        ></el-option>
                                                      </el-select>
                                                    </div>
                                                  </template>
                                                  <!-- 相对当前时间区间 -->
                                                  <template
                                                    v-if="
                                                      subRule.symbol[0] ===
                                                        'RELATIVE BETWEEN TIME'
                                                    "
                                                  >
                                                    <div
                                                      class="mt10 relative-between-time"
                                                    >
                                                      <span class="mr10 m-size"
                                                        >在</span
                                                      >
                                                      <el-select
                                                        size="small"
                                                        style="width: 120px"
                                                        class="mr10"
                                                        :disabled="disabled"
                                                        v-model="
                                                          subRule.relativeDateType
                                                        "
                                                      >
                                                        <el-option
                                                          label="过去"
                                                          value="PAST TIMES"
                                                        ></el-option>
                                                        <el-option
                                                          label="未来"
                                                          value="FUTURE"
                                                        ></el-option>
                                                      </el-select>
                                                      <el-input
                                                        class="mr10"
                                                        size="small"
                                                        type="number"
                                                        :disabled="disabled"
                                                        v-model="
                                                          subRule.betweenStartDay
                                                        "
                                                        placeholder="天数"
                                                        style="width: 100px"
                                                      ></el-input>
                                                      <span class="mr10"
                                                        >天至<template
                                                          v-if="
                                                            subRule.relativeDateType ===
                                                              'PAST TIMES'
                                                          "
                                                        >
                                                          过去
                                                        </template>
                                                        <template v-else
                                                          >未来</template
                                                        >
                                                      </span>
                                                      <el-input
                                                        class="mr10"
                                                        size="small"
                                                        type="number"
                                                        :disabled="disabled"
                                                        v-model="
                                                          subRule.betweenEndDay
                                                        "
                                                        placeholder="天数"
                                                        style="width: 100px"
                                                      ></el-input>
                                                      天之内
                                                    </div>
                                                  </template>
                                                </template>
                                                <el-button
                                                  type="text"
                                                  size="small"
                                                  class="gray"
                                                  @click="
                                                    removeSubRule(
                                                      behavior,
                                                      subI
                                                    )
                                                  "
                                                >
                                                  删除
                                                </el-button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <el-button
                                          type="text"
                                          size="small"
                                          class="primary"
                                          v-if="!disabled"
                                          @click="addEvent(rule)"
                                        >
                                          + 添加事件
                                        </el-button>
                                      </template>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex" v-if="!disabled">
                                  <div class="add-wrapper flex flex-center">
                                    <span
                                      class="hmicon icon-hao pointer"
                                      @click="addChildren(rule, item.type)"
                                    ></span>
                                  </div>
                                  <div class="minus-wrapper">
                                    <span
                                      class="hmicon icon-jianhao pointer"
                                      @click="removeChild(item, ruleIndex)"
                                    ></span>
                                  </div>
                                </div>
                              </div>
                              <!-- 第三层条件 -->
                              <div
                                class="child-condition flex-between"
                                v-if="rule.rules.length"
                              >
                                <div
                                  class="relation-wrapper"
                                  @click="changeRelation(rule)"
                                >
                                  <span
                                    class="relation pointer"
                                    v-if="rule.relation === 'and'"
                                    >且</span
                                  >
                                  <span class="relation pointer" v-else
                                    >或</span
                                  >
                                </div>
                                <div
                                  class="last-header flex"
                                  v-for="(condition,
                                  conditionIndex) in rule.rules"
                                  :key="conditionIndex"
                                >
                                  <div class="conditions flex-1">
                                    <div class="flex">
                                      <div
                                        class="index-wrapper child flex flex-center item-center"
                                      >
                                        {{ index2Letter(ruleIndex)
                                        }}{{ conditionIndex + 1 }}
                                      </div>
                                      <div class="flex-1">
                                        <template
                                          v-if="item.type === 'user_attr'"
                                        >
                                          <el-select
                                            :disabled="disabled"
                                            v-model="condition.userAttr"
                                            size="small"
                                            value-key="id"
                                            style="width: 140px"
                                            @change="getUserAttr(condition)"
                                            class="mr10"
                                            placeholder="请选择属性"
                                          >
                                            <el-option
                                              v-for="(attr, aI) in userAttrList"
                                              :key="aI"
                                              :label="
                                                attr.ruleName +
                                                  '(' +
                                                  attr.calcMode +
                                                  ')'
                                              "
                                              :value="attr"
                                            ></el-option>
                                          </el-select>
                                          <el-cascader
                                            size="small"
                                            :disabled="disabled"
                                            v-model="condition.symbol"
                                            style="width: 140px"
                                            class="mr10 tag-cascader"
                                            :options="condition.options"
                                            :show-all-levels="false"
                                          ></el-cascader>

                                          <el-select
                                            v-if="
                                              condition &&
                                                condition.userAttr &&
                                                condition.userAttr.allAList
                                            "
                                            clearable
                                            v-model="condition.value"
                                            size="small"
                                            class="mr10 flex-1"
                                            placeholder="请选择商品品牌"
                                          >
                                            <el-option
                                              :label="v.brandName"
                                              :value="v.brandId"
                                              v-for="(v,
                                              i) in allBrandList.records"
                                              :key="i"
                                            ></el-option>
                                          </el-select>
                                          <!-- 微店分类 allBList 判断是否是下拉菜单 -->
                                          <el-cascader
                                            v-if="
                                              condition &&
                                                condition.userAttr &&
                                                condition.userAttr.allBList
                                            "
                                            v-model="condition.value"
                                            :show-all-levels="false"
                                            size="small"
                                            class="mr10 flex-1"
                                            :props="categoryProp"
                                            clearable
                                            placeholder="请选择微店商品分类"
                                          ></el-cascader>
                                          <!-- 非日期类型 -->
                                          <el-input
                                            v-if="
                                              condition.userAttr &&
                                                (condition.userAttr.calcMode ===
                                                  'string' ||
                                                  condition.userAttr
                                                    .calcMode === 'int') &&
                                                condition.symbol &&
                                                condition.symbol[0] !==
                                                  'IS NOT NULL' &&
                                                condition.symbol[0] !==
                                                  'NULL' &&
                                                !condition.userAttr.allAList &&
                                                !condition.userAttr.allBList
                                            "
                                            size="small"
                                            style="width: 140px"
                                            :disabled="disabled"
                                            v-model="condition.value"
                                            placeholder="请输入值"
                                          ></el-input>
                                          <!-- 日期类型 -->
                                          <template
                                            v-if="
                                              condition.symbol &&
                                                condition.symbol[0]">
                                            <!-- 绝对时间 -->
                                            <template
                                              v-if="
                                                condition.symbol[0] ===
                                                  'ABSOLUTE TIME'
                                              "
                                            >
                                              <template
                                                v-if="
                                                  condition.symbol[1] !==
                                                    'BETWEEN'
                                                "
                                              >
                                                <el-date-picker
                                                  :disabled="disabled"
                                                  v-model="condition.value"
                                                  type="date"
                                                  size="small"
                                                  value-format="yyyy-MM-dd"
                                                  format="yyyy-MM-dd"
                                                  class="tag-datepicker mr10"
                                                  style="width: 140px"
                                                  placeholder="选择日期"
                                                >
                                                </el-date-picker>
                                              </template>
                                              <template v-else>
                                                <div class="mt10">
                                                  <el-date-picker
                                                    :disabled="disabled"
                                                    v-model="condition.value"
                                                    type="datetimerange"
                                                    class="mr10"
                                                    value-format="yyyy-MM-dd HH:mm:ss"
                                                    format="yyyy-MM-dd HH:mm:ss"
                                                    size="small"
                                                    range-separator="至"
                                                    start-placeholder="开始日期"
                                                    end-placeholder="结束日期"
                                                  >
                                                  </el-date-picker>
                                                </div>
                                              </template>
                                            </template>
                                            <!-- 相对当前时间 -->
                                            <template
                                              v-if="
                                                condition.symbol[0] ===
                                                  'RELATIVE TIME'
                                              "
                                            >
                                              <div class="mt10">
                                                <span class="mr10 m-size"
                                                  >在</span
                                                >
                                                <el-select
                                                  size="small"
                                                  style="width: 120px"
                                                  class="mr10"
                                                  :disabled="disabled"
                                                  v-model="
                                                    condition.relativeDateType
                                                  "
                                                >
                                                  <el-option
                                                    label="过去"
                                                    value="PAST TIMES"
                                                  ></el-option>
                                                  <el-option
                                                    label="未来"
                                                    value="FUTURE"
                                                  ></el-option>
                                                </el-select>
                                                <el-input
                                                  size="small"
                                                  style="width: 120px"
                                                  class="mr10"
                                                  :disabled="disabled"
                                                  v-model="condition.value"
                                                  type="number"
                                                  placeholder="天数"
                                                ></el-input>
                                                <span class="mr10 m-size"
                                                  >天</span
                                                >
                                                <el-select
                                                  size="small"
                                                  style="width: 120px"
                                                  :disabled="disabled"
                                                  v-model="
                                                    condition.relativeDateRange
                                                  "
                                                >
                                                  <el-option
                                                    label="之内"
                                                    value="WITHIN"
                                                  ></el-option>
                                                  <el-option
                                                    label="之前"
                                                    v-if="
                                                      condition.relativeDateType ===
                                                        'PAST TIMES'
                                                    "
                                                    value="BEFORE"
                                                  ></el-option>
                                                  <el-option
                                                    v-else
                                                    label="之后"
                                                    value="AFTER"
                                                  ></el-option>
                                                </el-select>
                                              </div>
                                            </template>
                                            <!-- 相对当前时间区间 -->
                                            <template
                                              v-if="
                                                condition.symbol[0] ===
                                                  'RELATIVE BETWEEN TIME'
                                              "
                                            >
                                              <div
                                                class="mt10 relative-between-time"
                                              >
                                                <span class="mr10 m-size"
                                                  >在</span
                                                >
                                                <el-select
                                                  size="small"
                                                  style="width: 120px"
                                                  class="mr10"
                                                  :disabled="disabled"
                                                  v-model="
                                                    condition.relativeDateType
                                                  "
                                                >
                                                  <el-option
                                                    label="过去"
                                                    value="PAST TIMES"
                                                  ></el-option>
                                                  <el-option
                                                    label="未来"
                                                    value="FUTURE"
                                                  ></el-option>
                                                </el-select>
                                                <el-input
                                                  class="mr10"
                                                  size="small"
                                                  type="number"
                                                  :disabled="disabled"
                                                  v-model="
                                                    condition.betweenStartDay
                                                  "
                                                  placeholder="天数"
                                                  style="width: 100px"
                                                ></el-input>
                                                <span class="mr10"
                                                  >天至<template
                                                    v-if="
                                                      condition.relativeDateType ===
                                                        'PAST TIMES'
                                                    "
                                                  >
                                                    过去
                                                  </template>
                                                  <template v-else
                                                    >未来</template
                                                  >
                                                </span>
                                                <el-input
                                                  class="mr10"
                                                  size="small"
                                                  type="number"
                                                  :disabled="disabled"
                                                  v-model="
                                                    condition.betweenEndDay
                                                  "
                                                  placeholder="天数"
                                                  style="width: 100px"
                                                ></el-input>
                                                天之内
                                              </div>
                                            </template>
                                          </template>
                                        </template>
                                        <template
                                          v-if="item.type === 'user_behavior' && queryType != 'goods' ">
                                          <div class="flex flex-wrap">
                                            <el-select
                                              size="small"
                                              style="width: 100px"
                                              class="mr10"
                                              @change="
                                                changeTimeType(condition)
                                              "
                                              :disabled="disabled"
                                              v-model="condition.timeType">
                                              <el-option
                                                label="绝对时间"
                                                value="absolute"
                                              ></el-option>
                                              <el-option
                                                label="相对时间"
                                                value="relative"
                                              ></el-option>
                                            </el-select>
                                            <el-date-picker
                                              v-if="condition.timeType ==='absolute'"
                                              :disabled="disabled"
                                              v-model="condition.behaviorDate"
                                              type="daterange"
                                              size="small"
                                              class="mr10"
                                              value-format="yyyy-MM-dd"
                                              format="yyyy-MM-dd"
                                              :picker-options="pickerOptions2"
                                              range-separator="至"
                                              start-placeholder="开始日期"
                                              end-placeholder="结束日期"
                                            >
                                            </el-date-picker>
                                            <div class="m-size" v-else>
                                              <span class="mr10">过去</span>
                                              <el-input
                                                size="small"
                                                type="number"
                                                style="width: 60px"
                                                class="mr10"
                                                :disabled="disabled"
                                                v-model="
                                                  condition.behaviorStartDate
                                                "
                                              ></el-input>
                                              <span class="mr10">天至过去</span>
                                              <el-input
                                                type="number"
                                                size="small"
                                                style="width: 60px"
                                                class="mr10"
                                                :disabled="disabled"
                                                v-model="
                                                  condition.behaviorStartEndDate
                                                "
                                              ></el-input>
                                              <span class="mr10">天</span>
                                            </div>
                                            <el-select
                                              size="small"
                                              style="width: 90px"
                                              class="mr10"
                                              :disabled="disabled"
                                              v-model="condition.isDoing" >
                                              <el-option
                                                label="做过"
                                                value="YES"
                                              ></el-option>
                                              <!-- <el-option
                                                label="未做过"
                                                value="NO"
                                              ></el-option> -->
                                            </el-select>
                                            <el-select
                                              :disabled="disabled"
                                              v-model="condition.behavior"
                                              size="small"
                                              value-key="id"
                                              style="width: 140px"
                                              @change="
                                                getUserBehaver(condition)
                                              "
                                              class="mr10"
                                              placeholder="请选择属性"
                                            >
                                              <el-option
                                                v-for="(behavior,
                                                bI) in userBehaviorList"
                                                :key="bI"
                                                :label="
                                                  behavior.ruleName +
                                                    '(' +
                                                    behavior.calcMode +
                                                    ')'
                                                "
                                                :value="behavior"
                                              ></el-option>
                                            </el-select>
                                            <el-button
                                              @click="
                                                addFilterCondition(condition)
                                              "
                                              v-if="
                                                !disabled &&
                                                  condition.isDoing != 'NO'
                                              "
                                              size="small"
                                              type="text"
                                              class="pray"
                                              >+ 添加筛选</el-button
                                            >
                                          </div>
                                          <div
                                            class="mt10 mb10 flex subrule-container"
                                            v-if="condition.subRule.length"
                                          >
                                            <span class="m-size type"
                                              >并且满足</span
                                            >
                                            <!-- 子条件 -->
                                            <div class="subrule-wrapper" v-if="rule.isDoing=='YES'">
                                              <div
                                                class="relation-wrapper"
                                                @click="
                                                  changeSubruleRelation(
                                                    condition
                                                  )
                                                "
                                              >
                                                <span
                                                  class="relation pointer"
                                                  v-if="
                                                    condition.subRuleRelation ===
                                                      'and'
                                                  "
                                                  >且</span
                                                >
                                                <span
                                                  class="relation pointer"
                                                  v-else
                                                  >或</span
                                                >
                                              </div>
                                              <div
                                                v-for="(subRule,
                                                subI) in condition.subRule"
                                                class="sub-rule"
                                                :key="subI"
                                              >
                                                <el-select
                                                  :disabled="disabled"
                                                  v-model="subRule.userAttr"
                                                  size="small"
                                                  value-key="id"
                                                  style="width: 140px"
                                                  @change="
                                                    getSubRuleUserAttr(subRule)
                                                  "
                                                  class="mr10"
                                                  placeholder="请选择属性"
                                                >
                                                  <el-option
                                                    v-for="(attr,
                                                    aI) in userGoodsAttr"
                                                    :key="aI"
                                                    :label="
                                                      attr.ruleName +
                                                        '(' +
                                                        attr.calcMode +
                                                        ')'
                                                    "
                                                    :value="attr"
                                                  ></el-option>
                                                </el-select>
                                                <el-cascader
                                                  size="small"
                                                  :disabled="disabled"
                                                  v-model="subRule.symbol"
                                                  style="width: 140px"
                                                  class="mr10 tag-cascader"
                                                  :options="subRule.options"
                                                  :show-all-levels="false"
                                                ></el-cascader>
                                                <el-select
                                                    v-if="
                                                  subRule &&
                                                    subRule.userAttr &&
                                                    subRule.userAttr.allAList"
                                                    clearable
                                                    v-model="subRule.value"
                                                    size="small"
                                                    class="mr10 flex-1"
                                                    placeholder="请选择商品品牌">
                                                  <el-option
                                                      :label="v.brandName"
                                                      :value="v.brandId"
                                                      v-for="(v,
                                                  i) in allBrandList.records"
                                                      :key="i"
                                                  ></el-option>
                                                </el-select>
                                                <!-- 微店分类 allBList 判断是否是下拉菜单 -->
                                                <el-cascader
                                                    v-if="
                                                  subRule &&
                                                    subRule.userAttr &&
                                                    subRule.userAttr.allBList"
                                                    v-model="subRule.value"
                                                    :show-all-levels="false"
                                                    size="small"
                                                    class="mr10 flex-1"
                                                    :props="categoryProp"
                                                    clearable
                                                    placeholder="请选择微店商品分类"
                                                ></el-cascader>
                                                <!-- 非日期类型 -->
                                                <el-input
                                                  v-if="
                                                    subRule.userAttr &&
                                                      (subRule.userAttr
                                                        .calcMode ===
                                                        'string' ||
                                                        subRule.userAttr
                                                          .calcMode ===
                                                          'int') &&
                                                      subRule.symbol &&
                                                      subRule.symbol[0] !==
                                                        'IS NOT NULL' &&
                                                      subRule.symbol[0] !==
                                                        'NULL'
                                                  "
                                                  size="small"
                                                  style="width: 140px"
                                                  class="mr10"
                                                  :disabled="disabled"
                                                  v-model="subRule.value"
                                                  placeholder="请输入值"
                                                ></el-input>
                                                <!-- 日期类型 -->
                                                <template
                                                  v-if="
                                                    subRule.symbol &&
                                                      subRule.symbol[0]
                                                  "
                                                >
                                                  <!-- 绝对时间 -->
                                                  <template
                                                    v-if="
                                                      subRule.symbol[0] ===
                                                        'ABSOLUTE TIME'
                                                    "
                                                  >
                                                    <template
                                                      v-if="
                                                        subRule.symbol[1] !==
                                                          'BETWEEN'
                                                      "
                                                    >
                                                      <el-date-picker
                                                        :disabled="disabled"
                                                        v-model="subRule.value"
                                                        type="date"
                                                        size="small"
                                                        class="tag-datepicker mr10"
                                                        style="width: 140px"
                                                        value-format="yyyy-MM-dd"
                                                        format="yyyy-MM-dd"
                                                        placeholder="选择日期"
                                                      >
                                                      </el-date-picker>
                                                    </template>
                                                    <template v-else>
                                                      <div class="mt10">
                                                        <el-date-picker
                                                          :disabled="disabled"
                                                          v-model="
                                                            subRule.value
                                                          "
                                                          type="datetimerange"
                                                          class="mr10"
                                                          size="small"
                                                          value-format="yyyy-MM-dd HH:mm:ss"
                                                          format="yyyy-MM-dd HH:mm:ss"
                                                          range-separator="至"
                                                          start-placeholder="开始日期"
                                                          end-placeholder="结束日期"
                                                        >
                                                        </el-date-picker>
                                                      </div>
                                                    </template>
                                                  </template>
                                                  <!-- 相对当前时间 -->
                                                  <template
                                                    v-if="
                                                      subRule.symbol[0] ===
                                                        'RELATIVE TIME'
                                                    "
                                                  >
                                                    <div class="mt10">
                                                      <span class="mr10 m-size"
                                                        >在</span
                                                      >
                                                      <el-select
                                                        size="small"
                                                        style="width: 120px"
                                                        class="mr10"
                                                        :disabled="disabled"
                                                        v-model="
                                                          subRule.relativeDateType
                                                        "
                                                      >
                                                        <el-option
                                                          label="过去"
                                                          value="PAST TIMES"
                                                        ></el-option>
                                                        <el-option
                                                          label="未来"
                                                          value="FUTURE"
                                                        ></el-option>
                                                      </el-select>
                                                      <el-input
                                                        size="small"
                                                        style="width: 120px"
                                                        class="mr10"
                                                        :disabled="disabled"
                                                        v-model="subRule.value"
                                                        type="number"
                                                        placeholder="天数"
                                                      ></el-input>
                                                      <span class="mr10 m-size"
                                                        >天</span
                                                      >
                                                      <el-select
                                                        size="small"
                                                        style="width: 120px"
                                                        :disabled="disabled"
                                                        v-model="
                                                          subRule.relativeDateRange
                                                        "
                                                      >
                                                        <el-option
                                                          label="之内"
                                                          value="WITHIN"
                                                        ></el-option>
                                                        <el-option
                                                          label="之前"
                                                          v-if="
                                                            subRule.relativeDateType ===
                                                              'PAST TIMES'
                                                          "
                                                          value="BEFORE"
                                                        ></el-option>
                                                        <el-option
                                                          v-else
                                                          label="之后"
                                                          value="AFTER"
                                                        ></el-option>
                                                      </el-select>
                                                    </div>
                                                  </template>
                                                  <!-- 相对当前时间区间 -->
                                                  <template
                                                    v-if="
                                                      subRule.symbol[0] ===
                                                        'RELATIVE BETWEEN TIME'
                                                    "
                                                  >
                                                    <div
                                                      class="mt10 relative-between-time"
                                                    >
                                                      <span class="mr10 m-size"
                                                        >在</span
                                                      >
                                                      <el-select
                                                        size="small"
                                                        style="width: 120px"
                                                        class="mr10"
                                                        :disabled="disabled"
                                                        v-model="
                                                          subRule.relativeDateType
                                                        "
                                                      >
                                                        <el-option
                                                          label="过去"
                                                          value="PAST TIMES"
                                                        ></el-option>
                                                        <el-option
                                                          label="未来"
                                                          value="FUTURE"
                                                        ></el-option>
                                                      </el-select>
                                                      <el-input
                                                        class="mr10"
                                                        size="small"
                                                        type="number"
                                                        :disabled="disabled"
                                                        v-model="
                                                          subRule.betweenStartDay
                                                        "
                                                        placeholder="天数"
                                                        style="width: 100px"
                                                      ></el-input>
                                                      <span class="mr10"
                                                        >天至<template
                                                          v-if="
                                                            subRule.relativeDateType ===
                                                              'PAST TIMES'
                                                          "
                                                        >
                                                          过去
                                                        </template>
                                                        <template v-else
                                                          >未来</template
                                                        >
                                                      </span>
                                                      <el-input
                                                        class="mr10"
                                                        size="small"
                                                        type="number"
                                                        :disabled="disabled"
                                                        v-model="
                                                          subRule.betweenEndDay
                                                        "
                                                        placeholder="天数"
                                                        style="width: 100px"
                                                      ></el-input>
                                                      天之内
                                                    </div>
                                                  </template>
                                                </template>
                                                <el-button
                                                  type="text"
                                                  size="small"
                                                  class="gray"
                                                  @click="
                                                    removeSubRule(
                                                      condition,
                                                      subI
                                                    )
                                                  "
                                                >
                                                  删除
                                                </el-button>
                                              </div>
                                            </div>
                                          </div>
                                          <div
                                            class="mr10 mt10"
                                            v-if="condition.isDoing === 'YES'"
                                          >
                                            <el-select
                                              :disabled="disabled"
                                              v-model="condition.behaviorType"
                                              size="small"
                                              value-key="id"
                                              style="width: 140px"
                                              class="mr10"
                                              placeholder="请选择行为类型"
                                            >
                                              <el-option
                                                v-for="(behaviorType,
                                                btI) in behaviorTypeList"
                                                :key="btI"
                                                :label="behaviorType.name"
                                                :value="behaviorType.value"
                                              ></el-option>
                                            </el-select>
                                            <!-- 符号 -->
                                            <el-select
                                              :disabled="disabled"
                                              v-model="condition.behaviorSymol"
                                              size="small"
                                              value-key="id"
                                              style="width: 100px"
                                              class="mr10"
                                              placeholder="符号"
                                            >
                                              <el-option
                                                v-for="(behaviorSymol,
                                                bsI) in behaviorSymbolList"
                                                :key="bsI"
                                                :label="behaviorSymol.label"
                                                :value="behaviorSymol.value"
                                              ></el-option>
                                            </el-select>
                                            <!-- 非区间 -->
                                            <template
                                              v-if="
                                                condition.behaviorSymol !==
                                                  'BETWEEN'
                                              "
                                            >
                                              <el-input
                                                class="mr10"
                                                :disabled="disabled"
                                                v-model="condition.times"
                                                size="small"
                                                type="number"
                                                style="width: 80px"
                                                placeholder="次数"
                                              ></el-input>
                                              <span class="m-size">次</span>
                                            </template>
                                            <template v-else>
                                              <el-input
                                                class="mr10"
                                                :disabled="disabled"
                                                v-model="condition.lowerTimes"
                                                size="small"
                                                type="number"
                                                style="width: 60px"
                                                placeholder="次数"
                                              ></el-input>
                                              <span class="m-size mr10"
                                                >至</span
                                              >
                                              <el-input
                                                class="mr10"
                                                :disabled="disabled"
                                                v-model="condition.upperTimes"
                                                size="small"
                                                type="number"
                                                style="width: 60px"
                                                placeholder="次数"
                                              ></el-input>
                                              <span class="m-size">次</span>
                                            </template>
                                          </div>
                                        </template>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="flex">
                                    <div class="minus-wrapper">
                                      <span
                                        class="hmicon icon-jianhao pointer"
                                        @click="
                                          removeChild(rule, conditionIndex)
                                        "
                                      ></span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </template>
              </div>
              <!-- foot -->
              <el-form-item
                :label="queryType === 'user' ? '测试人数' : '测试商品'"
              >
                <el-input
                  size="small"
                  type="number"
                  class="mr20"
                  v-model="ruleForm.testNum"
                ></el-input>
                <el-button @click="testTags" size="small" type="warning"
                  >测试一下</el-button
                >
              </el-form-item>
            </template>

            <template v-if="currentWay.wayName === 'sql'">
              <div
                class="mb20 flex item-center m-size"
                v-if="ruleForm.forever !== 'yes'"
              >
                失效时间：
                <el-select
                  v-model="ruleForm.invalidId"
                  size="small"
                  style="width: 180px"
                  class="mr10"
                  placeholder="请选择失效时间类型"
                >
                  <el-option
                    v-for="(type, tI) in invalidBaseList"
                    :key="tI"
                    :label="type.name"
                    :value="type.id"
                  ></el-option>
                </el-select>
                <div>
                  <span class="mr10">未来</span>
                  <el-input
                    style="width: 80px"
                    size="small"
                    class="mr10"
                    v-model="ruleForm.invalidDate"
                  ></el-input
                  >天之后
                </div>
              </div>
              <set-sql-rule
                @getFileds="getFileds"
                :sql="sql"
                :resultType="ruleForm.resultType"
                @getSql="getSql"
              ></set-sql-rule>
            </template>
          </template>
        </el-form>
      </div>
      <div class="footer flex flex-center">
        <el-button size="small" @click="closeDrawer">取消</el-button>
        <el-button
          size="small"
          v-if="currentStep === 1"
          type="primary"
          @click="checkToNextStep(2)"
          >下一步</el-button
        >
        <el-button
          size="small"
          v-if="currentStep === 2"
          type="primary"
          plain
          @click="checkToNextStep(1)"
          >上一步</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="submitTag"
          v-if="currentStep === 2 && !audit"
          >创建</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="auditTag('yes')"
          v-if="audit"
          >审批通过</el-button
        >
        <el-button
          type="warning"
          size="small"
          @click="auditTag('no')"
          v-if="audit"
          >审批驳回
        </el-button>
        <el-button type="warning" size="small" @click="changeBtn"
          >手动更新
        </el-button>
        <el-button size="small" @click="emptyBtn"
          >清空标签数据
        </el-button>
      </div>
    </div>
    <el-dialog
      title="提示"
      width="800px"
      :modal="false"
      :visible.sync="exampleDialogVisible"
    >
      <!-- 多属性标签 -->
      <div class="example-list">
        <template v-for="(v, i) in exampleList">
          <div class="example" :key="i" v-if="v.wayName === currentWay.wayName">
            <div>{{ v.tips1 }}</div>
            <div class="img-wrapper">
              <img :src="v.img" alt="" />
            </div>
            <div>{{ v.tips2 }}</div>
          </div>
        </template>
      </div>
      <div class="example-footer flex flex-center">
        <el-button size="small" @click="exampleDialogVisible = false"
          >关闭</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="新增分类"
      :visible.sync="cationsdialogVisible"
      :append-to-body="true"
      label-width="120px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="分类层级">
          <el-radio-group
            v-model="ruleForm.level"
            :disabled="mode === 'addChild'"
            @change="switchLevel"
          >
            <el-radio :label="1">一级分类</el-radio>
            <el-radio :label="2">子分类</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="分类名称" prop="catName">
          <el-input
            v-model="ruleForm.catName"
            maxlength="20"
            size="small"
            style="width:220px"
            placeholder="请输入单行文本，限制20个字符"
          ></el-input>
        </el-form-item>
        <el-form-item label="上级分类" v-if="ruleForm.level === 2">
          <el-cascader
            v-if="mode !== 'addChild'"
            ref="cascader"
            v-model="ruleForm.catId"
            :disabled="ruleForm.level === 1"
            :options="options"
            :props="props"
            :show-all-levels="false"
            size="small"
          ></el-cascader>
          <el-input
            v-if="mode === 'addChild'"
            :value="currentRow.catName"
            size="small"
            type="text"
            disabled
          />
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="save"
          :disabled="!ruleForm.catId.length && ruleForm.level === 2"
          >确 定</el-button
        >
        <el-button size="small" @click="cationsdialogVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>

    <test-tag
      :list="catgorTestList"
      :testTagDialogVisible="testTagDialogVisible"
      @closeTestTagDialog="testTagDialogVisible = false"
    ></test-tag>
  </el-drawer>
</template>

<script>
import HmStep from "@/components/HmStep";
import pinyin from "pinyin";
import moment from "moment";
import { mapGetters } from "vuex";
import testTag from "@/views/portraitLabelMgt/modules/testTag";
import setSqlRule from "@/views/portraitLabelMgt/modules/setSqlRule";
export default {
  components: {
    HmStep,
    testTag,
    setSqlRule
  },
  props: {
    queryTagDetailsId: {
      type: String,
      default: false
    },
    audit: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tagDetails: {
      type: Object,
      default: null
    },
    draggableShow: {
      type: Boolean,
      default: false
    },
    drawerVisible: {
      type: Boolean,
      default: false
    },
    queryType: {
      type: String,
      default: "user"
    },
    tagCat: {
      type: String,
      default: ""
    },
    currentWay: {
      type: Object,
      default: () => {
        return {
          type: "view",
          name: ""
        };
      }
    }
  },
  data() {
    return {
      categoryProp: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1,
                storeCode: this.ruleForm.tenantId
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId,
                storeCode: this.ruleForm.tenantId
              })
              .then(res => {
                console.log("categoryProp===", res);
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      value1: "",
      value2: "",
      catgorTestList: [],
      resultType: "",
      testTagDialogVisible: false,
      tagRunInfo: [],
      sql: "",
      options: [],
      activeTagTab: 0,
      exampleDialogVisible: false,
      currentStep: 1,
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
      mode: "add",
      props: {
        value: "id",
        label: "catName",
        checkStrictly: true
      },
      cationsdialogVisible: false,
      ruless: {
        catName: {
          required: true,
          trrger: "blur",
          message: "请输入分类名"
        },
        isFrontShow: {
          required: true,
          trrger: "blur",
          message: "请选择"
        }
      },
      ruleFormopen: {
        isFrontShow: "yes",
        catId: [],
        level: 1,
        categoryLogo: "",
        catName: "",
        seqNum: "",

      },
      editableTabs: [
        {
          title: "标签值1"
        }
      ],
      catProps: {
        value: "id",
        label: "catName"
        // checkStrictly: true
      },
      catOptions: [],
      updateCycleList: [
        {
          name: "每天更新",
          value: "day"
        },
        {
          name: "每周更新",
          value: "week"
        },
        {
          name: "每月更新",
          value: "month"
        },
        {
          name: "每年更新",
          value: "year"
        }
      ],
      behaviorTypeList: [
        {
          name: "总次数",
          value: "TOTAL TIMES"
        }
      ],
      steps: [
        {
          name: "设置基础信息"
        },
        {
          name: "设置标签规则"
        }
      ],
      behaviorSymbolList: [
        {
          label: "等于",
          value: "="
        },
        {
          label: "不等于",
          value: "!="
        },
        {
          label: "小于",
          value: "<"
        },
        {
          label: "小于等于",
          value: "<="
        },
        {
          label: "大于",
          value: ">"
        },
        {
          label: "大于等于",
          value: ">="
        },
        {
          label: "区间",
          value: "BETWEEN"
        }
      ],
      invalidBaseList: [],
      stringSymbolList: [
        {
          label: "等于",
          value: "="
        },
        {
          label: "文字匹配",
          value: "LIKE"
        },
        {
          label: "包含(含子级)",
          value: "LIKE"
        },
        {
          label: "小于",
          value: "<"
        },
        {
          label: "大于",
          value: ">"
        },
        {
          label: "区间",
          value: "BETWEEN"
        }
      ],
      intSymbolList: [
        {
          label: "等于",
          value: "="
        },
        {
          label: "不等于",
          value: "!="
        },
        {
          label: "小于",
          value: "<"
        },
        {
          label: "大于",
          value: ">"
        },
        {
          label: "区间",
          value: "BETWEEN"
        },
        {
          label: "有值",
          value: "IS NOT NULL"
        },
        {
          label: "没值",
          value: "NULL"
        }
      ],
      dateSymbolList: [
        {
          label: "绝对时间",
          value: "ABSOLUTE TIME",
          children: [
            {
              label: "等于",
              value: "="
            },
            {
              label: "不等于",
              value: "!="
            },
            {
              label: "小于",
              value: "<"
            },
            {
              label: "小于等于",
              value: "<="
            },
            {
              label: "大于",
              value: ">"
            },
            {
              label: "大于等于",
              value: ">="
            },
            {
              label: "区间",
              value: "BETWEEN"
            }
          ]
        },
        {
          label: "相对当前时间",
          value: "RELATIVE TIME"
        },
        {
          label: "相对当前时间区间",
          value: "RELATIVE BETWEEN TIME"
        },
        {
          label: "有值",
          value: "IS NOT NULL"
        },
        {
          label: "没值",
          value: "NULL"
        }
      ],
      booleanSymbolList: [
        {
          label: "是",
          value: "TRUE"
        },
        {
          label: "否",
          value: "FALSE"
        }
      ],
      datasoureList: [],
      storeCodeList: [],
      allMerchant: [],
      userAttrList: [],
      currentPage: 1,
      pageSize: 10,
      categoryList: [],
      total: 0,
      userBehaviorList: [],
      userGoodsAttr: [],
      ruleForm: {
        resultType: "",
        invalidId: "",
        catId: [],
        level: 1,
        invalidDate: "",
        forever: "yes",
        datasourceId: "1",
        tenantId: "",
        testNum: 10000,
        tagName: "",
        catName: "",
        tagKey: "",
        tagCatArray: [],
        tagUpdateTimeType: "day",
        tagUpdateTime: [
          moment().format("YYYY-MM-DD"),
          moment()
            .add(3, "years")
            .format("YYYY-MM-DD")
        ],
        tagRemark: "",
        showGroup: "no",
        showType: "",
      },
      rules: {
        datasourceId: {
          required: true,
          message: "请选择数据源",
          trigger: "change"
        },
        tenantId: {
          required: true,
          message: "请选择渠道",
          trigger: "change"
        },
        catName: {
          required: true,
          trrger: "blur",
          message: "请输入分类名"
        },
        tagName: {
          required: true,
          message: "请输入标签中文名称",
          trigger: "blur"
        },
        tagKey: {
          required: true,
          message: "请输入标签ID",
          trigger: "blur"
        },
        tagCatArray: {
          required: true,
          message: "请选择标签分类",
          trigger: "change"
        },
        tagUpdateTimeType: {
          required: true,
          message: "请选择更新周期",
          trigger: "change"
        },
        tagRemark: {
          required: true,
          message: "请输入标签含义",
          trigger: "blur"
        }
      },
      pickerOptions1: {
        shortcuts: [
          {
            text: "未来1年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "未来2年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365 * 2);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "未来3年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(end.getTime() + 3600 * 1000 * 24 * 365 * 3);
              picker.$emit("pick", [start, end]);
            }
          }
        ],
        disabledDate: time => {
          return time.getTime() < new Date().getTime() - 60 * 60 * 1000 * 24;
        }
      },
      pickerOptions2: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime());
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近30天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "近90天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ],
        disabledDate: time => {
          return time.getTime() > Date.now();
        }
      },
      exampleList: [
        {
          wayName: "multiAttr",
          tips1:
            "生产一个标签，根据设定的规则条件把用户划分为低价值、中价值和高价值三个群体。",
          img: "https://imgcdn.hemiao100.com/tag/multiAttr.svg",
          tips2:
            "该标签是一个字符串类型的标签，可以分别设定价值低、中和高的计算规则，其中高价值的规则为：用户需要满足在过去 7 天完成支付订单次数 ≥ 30 次并且过去 7 天的支付订单详情的商品金额总和 ≥ 6000。"
        },
        {
          wayName: "basicIndex",
          tips1:
            "生产一个标签，用来标记客户在过去 30 天内的支付订单的订单金额总和。",
          img: "https://imgcdn.hemiao100.com/tag/basicIndex.svg",
          tips2:
            "该标签是一个数值类型的标签，使用用户过去 30 天内的支付订单的金额总和作为标签的值，若用户分别支付了三张 100 元、150 元、300 元的订单，那么用户过去 30 天的消费金额总和为 550 元。"
        },
        {
          wayName: "characteristics",
          tips1: "生产一个标签，用来标记用户首次支付订单的距今天数。",
          img: "https://imgcdn.hemiao100.com/tag/characteristics.svg",
          tips2:
            "该标签是一个数值类型的标签，若用户第一次完成支付是发生在 2 日之前，那么会标记为 2。"
        },
        {
          wayName: "preferenceAttr",
          tips1:
            "生产一个标签，用来标记客户在支付订单金额高于 300 元的订单中，哪个商品类型更受客户自己的偏爱，记录客户最喜欢的前 3 个类型。",
          img: "https://imgcdn.hemiao100.com/tag/preferenceAttr.svg",
          tips2:
            "该标签是一个集合类型的标签，若用户在过去 7 天内，分别产生了 20 张商品订单，其中 5 张为母婴类产品，4 张为服饰类产品、4 张为生鲜类产品、3 张为手机数码、2 张为日用百货、2 张为其他商品；那么客户这个标签会被标记为偏好母婴、服饰和生鲜。"
        },
        {
          wayName: "behaviorDistributionResults",
          tips1:
            "生产一个标签，用来计算用户在过去 30 天内的登录 App 的天数分布。",
          img:
            "https://imgcdn.hemiao100.com/tag/behaviorDistributionResults.svg",
          tips2:
            "该标签是一个数值类型的标签，若用户在过去 30 天内，分别在第 1 至 5 天，20 至 30 天有过访问记录，那么这个标签会被标记为 16。"
        }
      ],
      showTypeList: [],
      groupList:[
        {
          name: "下拉框多选",
          value: "combobox",
        },
        {
          name: "平铺选项",
          value: "pave",
        },
        {
          name: "时间段选择",
          value: "date",
        },
        {
          name: "值比较",
          value: "compile",
        }
      ],
    };
  },
  created() {
    console.log("queryTagDetailsId----", this.queryTagDetailsId);
    this.ruleForm.tagCatArray = this.tagCat ? [this.tagCat] : [];
    this.queryTagAttrList();
    this.queryAllTag();
    this.queryDataSource();
    this.queryLabelStoreCode();
    this.queryTagInvalids();
    this.init();
    console.log('this.queryType---',this.queryType)
  },
  computed: mapGetters([
    "tagAttributeList",
    "microShopGoodsList",
    "allMicroShopGoodsList",
    "microShopStoreList",
    "allBrandList"
  ]),
  methods: {
    // 清空标签数据
    async init(){
      await this.$store.dispatch("queryBrandAllList", { pageSize: 999999, pageNo: 1 });
      console.log("this.tagDetails:",this.tagDetails);
      if (this.tagDetails) {
        this.feedBack();
      }
    },
    emptyBtn() {
      let params = {
        id: this.queryTagDetailsId
      };
      this.$confirm('您是否是要清空该标签的数据，清空后所有已经计算的数据将全部删除?', '温馨提示', {
        cancelButtonText: '暂不清空',
        confirmButtonText: '清空数据',
        type: 'warning'
      }).then(() => {
        let { res } = this.$store.dispatch("emptyTags", params);
        this.$message({
          type: 'success',
          message: '清空成功!'
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消清空'
        });
      });
    },

    // 手动更新
    changeBtn() {
      console.log("queryTagDetailsId----", this.queryTagDetailsId);
      let params = {
        id: this.queryTagDetailsId
      };
      const formData = new FormData();
      Object.keys(params).forEach(key => {
        formData.append(key, params[key]);
      });
      let { res } = this.$store.dispatch("queryRunCat", formData);
      setTimeout(() => {
        this.$message({
          message: `运行成功`,
          type: "success"
        });
      }, 1000);
    },
    changeTimeType(rule) {
      rule.behaviorStartDate = "";
      rule.behaviorStartEndDate = "";
      rule.behaviorDate = [];
    },
    // 回显数据
    feedBack() {
      for (let key in this.tagDetails) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = this.tagDetails[key];
        }
      }
      const {
        tagCat,
        tagUpdateStartTime,
        tagUpdateEndTime,
        createType,
        tagRunInfo,
        tagKey
      } = this.tagDetails;
      this.ruleForm.tenantId = this.tagDetails.tenantId;
      this.storeCodeList = this.allMerchant.filter(v => v.storeCode.indexOf(this.ruleForm.tenantId) > -1);
      this.ruleForm.tagCatArray = [tagCat];
      this.currentWay.wayName = createType;
      if (createType !== "sql") {
        this.tagRunInfo = JSON.parse(tagRunInfo);
      } else {
        this.sql = tagRunInfo;
      }
      this.ruleForm.tagKey = tagKey.split("_")[1];
      this.ruleForm.tagUpdateTime = [
        tagUpdateStartTime.split(" ")[0],
        tagUpdateEndTime.split(" ")[0]
      ];
      if(this.ruleForm.showType){
        this.showTypeList = this.ruleForm.showType.split(",");
      }
    },

    // 新增分类
    openCation() {
      this.cationsdialogVisible = true;
    },
    switchLevel() {
      this.ruleForm.catId = [];
    },
    save() {
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          let parentId = "";
          if (this.ruleForm.level === 1) {
            parentId = this.queryType === "user" ? 1 : 2;
          } else {
            parentId = this.ruleForm.catId[0];
          }
          let params = {
            catName: this.ruleForm.catName,
            parentId,
            level: this.ruleForm.level
          };
          let actionName = "addTagCategory";
          await this.$store.dispatch(actionName, params);
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.ruleForm;
          this.cationsdialogVisible = false;
          this.queryAllTag();
        } else {
          return false;
        }
      });
    },
    async queryAllTag() {
      const { result } = await this.$store.dispatch("queryAllTagCat", {
        queryType: this.queryType
      });
      this.catOptions = result;
      console.log("this.catOptions: ", this.catOptions);
      if (this.ruleForm.tagCatArray == undefined ||this.ruleForm.tagCatArray == null || this.ruleForm.tagCatArray.length <= 0) {
        this.ruleForm.tagCatArray = this.catOptions[0].id || "";
      }
      let newData = [];
      newData = JSON.parse(JSON.stringify(result));
      newData.forEach(v => {
        delete v.children;
      });
      console.log("newData: ", newData);
      this.options = newData;
    },
    async queryDataSource() {
      const { result } = await this.$store.dispatch("queryDataSource");
      this.datasoureList = result;
    },
    async queryLabelStoreCode() {
      const { result } = await this.$store.dispatch("queryLabelStoreCode");
      console.log("查询标签商城", result);
      // this.storeCodeList = result;
      this.allMerchant = result;
    },
    getSql(sql) {
      this.sql = sql;
    },
    auditTag(auditStatus) {
      this.$emit("audit", auditStatus);
    },
    // 选择用户属性下拉框
    getUserAttr(rule) {
      console.log("rule---下拉菜单1", rule);
      const calcMode = rule.userAttr.calcMode;
      rule.options = this[calcMode + "SymbolList"];

      let options1 = []
      let options2 = []
      let options3 = []
      let options4 = []
      rule.options.forEach(v => {
        if(v.label == "等于" || v.label == "文字匹配") {
          options1.push(v)
        }
        if(v.label == "包含(含子级)") {
          options2.push(v)
        }
        if(v.label == "等于") {
          options3.push(v)
        }
        if(v.label == "等于" || v.label == "小于" || v.label == "大于" || v.label == "区间") {
          options4.push(v)
        }
      })
      if(rule.userAttr.ruleName == "商品名称" || rule.userAttr.ruleName == '商品条码' ||  rule.userAttr.ruleName == '商品货号') {
         rule.options = options1
      }
      if(rule.userAttr.ruleName == '微店分类') {
        rule.options = options2
      }
      if(rule.userAttr.ruleName == '商品品牌') {
        rule.options = options3
      }
      if(rule.userAttr.ruleName == '商品价格') {
        rule.options = options4
      }
    },
    // 用户行为满足
    getSubRuleUserAttr(subRule) {
      console.log("下拉subRule----222", subRule);
      const calcMode = subRule.userAttr.calcMode;
      subRule.options = this[calcMode + "SymbolList"];
      console.log('subRule.options---行为满足',subRule.options)
      let options1 = []
      let options2 = []
      let options3 = []
      let options4 = []
      subRule.options.forEach(v => {
        if(v.label == "等于" || v.label == "文字匹配") {
          options1.push(v)
        }
        if(v.label == "包含(含子级)") {
          options2.push(v)
        }
        if(v.label == "等于") {
          options3.push(v)
        }
        if(v.label == "等于" || v.label == "小于" || v.label == "大于" || v.label == "区间") {
          options4.push(v)
        }
      })
      console.log('options1---',options1)
      if(subRule.userAttr.ruleName == "商品名称" || subRule.userAttr.ruleName == '商品条码' ||  subRule.userAttr.ruleName == '商品货号') {
         subRule.options = options1
      }
      if(subRule.userAttr.ruleName == '微店分类') {
        subRule.options = options2
      }
      if(subRule.userAttr.ruleName == '商品品牌') {
        subRule.options = options3
      }
      if(subRule.userAttr.ruleName == '商品价格') {
        subRule.options = options4
      }
    },
    getUserBehaver(e) {
      console.log('e----',e)
    },
    switchTagTab(i) {
      this.activeTagTab = i;
    },
    handleClose(i) {
      this.tagRunInfo.splice(i, 1);
    },
    getFileds(resultType) {
      this.ruleForm.resultType = resultType;
    },
    async queryTagInvalids() {
      const { result } = await this.$store.dispatch("queryTagInvalids");
      this.invalidBaseList = result;
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      if (this.tagRunInfo.length >= 49) {
        this.$message({
          type: "warning",
          message: "最多添加50个标签值"
        });
        return;
      }
      if (this.inputValue) {
        let multiAttrObj = {};
        // 多属性标签
        if (this.currentWay.wayName === "multiAttr") {
          let attrName = "";
          let behaviorName = "";
          if (this.queryType === "user") {
            attrName = "用户属性满足";
            behaviorName = "用户行为满足";
          } else {
            attrName = "商品属性满足";
            behaviorName = "用户对商品的行为满足";
          }
          multiAttrObj = {
            rules: [
              {
                type: "user_attr",
                name: attrName,
                relation: "and",
                collapse: false,
                rules: [],
                userAttr: {},
                symbol: [],
                relativeDateType: "PAST TIMES",
                relativeDateRange: "",
                betweenStartDay: "",
                betweenEndDay: "",
                value: ""
              },
              {
                type: "user_behavior",
                name: behaviorName,
                relation: "and",
                collapse: false,
                rules: [],
                relativeDateType: "PAST TIMES",
                relativeDateRange: "",
                betweenStartDay: "",
                betweenEndDay: "",
                value: ""
              },
              {
                type: "user_behavior_order",
                name: "行为序列",
                relation: "and",
                collapse: false,
                relativeDateType: "PAST TIMES",
                relativeDateRange: "",
                betweenStartDay: "",
                betweenEndDay: "",
                rules: [],
                value: ""
              }
            ],
            relation: "and"
          };
        }
        this.tagRunInfo.push({
          tagName: this.inputValue,
          comments: "",
          ...multiAttrObj
        });
      }
      this.inputVisible = false;
      this.inputValue = "";
      return false;
    },
    // 折叠与展开
    collapseItem(row, outSideRow) {
      if (!outSideRow.rules.length) {
        return;
      }
      row.collapse = !row.collapse;
      this.$forceUpdate();
    },
    // 添加第二层
    addChild(item) {
      let params = {
        type: "rules_relation",
        relation: "and",
        rules: [],
        level: 1,
        ...this.setConditions(item.type)
      };
      item.rules.push(params);
      if (item.collapse) {
        item.collapse = false;
      }
    },
    // 添加第三层
    addChildren(item, type) {
      let params = {
        relation: "and",
        value: "",
        level: 2,
        symbol: [], // 符号，一般索引0为符号，当数组长度大于1时表示为绝对时间，索引1代表符号
        relativeDateType: "PAST TIMES", // 仅当symbol长度大于1时出现 PAST TIMES代表过去 FUTURE代表未来
        relativeDateRange: "", // 仅当symbol长度大于1时出现 WITHIN 代表之内 BEFORE代表之前 AFTER代表之后
        betweenStartDay: "", // 仅当symbol[0] 为RELATIVE BETWEEN TIME出现
        betweenEndDay: "", // 仅当symbol[0] 为RELATIVE BETWEEN TIME出现
        ...this.setConditions(type)
      };
      item.rules.push(params);
    },
    // 删除用户行为子条件
    removeSubRule(rule, i) {
      rule.subRule.splice(i, 1);
      this.$forceUpdate();
    },
    setConditions(type) {
      let params = {
        relation: "and",
        timeType: "absolute", // 用户行为时间种类
        behaviorStartDate: "", // 过去x天起始天数
        behaviorStartEndDate: "", // 过去x天结束天数
        value: "",
        symbol: [], // 符号，一般索引0为符号，当数组长度大于1时表示为绝对时间，索引1代表符号
        relativeDateType: "PAST TIMES", // 仅当symbol长度大于1时出现 PAST TIMES代表过去 FUTURE代表未来
        relativeDateRange: "", // 仅当symbol长度大于1时出现 WITHIN 代表之内 BEFORE代表之前 AFTER代表之后
        betweenStartDay: "", // 仅当symbol[0] 为RELATIVE BETWEEN TIME出现
        betweenEndDay: "" // 仅当symbol[0] 为RELATIVE BETWEEN TIME出现
      };
      switch (type) {
        case "user_attr":
          params = {
            ...params,
            userAttr: {} // 用户属性
          };
          break;
        case "user_behavior":
          params = {
            ...params,
            behaviorDate: [], // 出现行为的日期
            isDoing: "YES", // 是否做过
            lowerTimes: "", // 选择区间范围最低值
            upperTimes: "", // 选择区间范围最高值
            subRule: [], // 子筛选
            subRuleRelation: "and"
          };
          break;
        case "user_behavior_order":
          params = {
            ...params,
            behaviorDate: [], // 出现行为的日期
            behaviorSteps: [
              {
                behavior: "",
                subRule: []
              }
            ]
          };
          break;
        default:
          break;
      }
      return params;
    },
    // 添加行为序列事件
    addEvent(rule) {
      rule.behaviorSteps.push({
        behavior: "",
        subRule: []
      });
    },
    removeEvent(rule, i) {
      rule.behaviorSteps.splice(i, 1);
    },
    // 添加筛选条件
    addFilterCondition(rule) {
      rule.subRule.push({
        subRuleRelation: "and"
      });
    },
    removeChild(item, index) {
      item.rules.splice(index, 1);
    },
    changeRelation(item) {
      item.relation = item.relation === "and" ? "or" : "and";
      this.$forceUpdate();
    },
    changeSubruleRelation(item) {
      item.subRuleRelation = item.subRuleRelation === "and" ? "or" : "and";
      this.$forceUpdate();
    },
    async submitTag() {
      await this.$refs.ruleForm.validate();
      let actionName = "createTag";
      let id = undefined;
      if (this.tagDetails) {
        actionName = "editTag";
        id = this.tagDetails.id;
      }
      // if (this.isCopy) {
      //   actionName = "copyTag"
      // }
      if (this.currentWay.wayName !== "sql") {
        this.tagRunInfo.forEach(v => {
          v.rules.forEach(o => {
            o.rules.forEach(p => {
              if (p.userAttr) {
                p.keyMap = p.userAttr.ruleName;
                p.calcMode = p.userAttr.calcMode;
              }
            });
          });
        });
      }
      await this.$store.dispatch(actionName, {
        ...this.ruleForm,
        tagCat: this.ruleForm.tagCatArray[0],
        tagKey: "pingtai_" + this.ruleForm.tagKey,
        tagRunInfo:
          this.currentWay.wayName === "sql"
            ? this.sql
            : JSON.stringify(this.tagRunInfo),
        tagUpdateStartTime: moment(this.ruleForm.tagUpdateTime[0]).format(
          "YYYY-MM-DD 00:00:00"
        ),
        tagUpdateEndTime: moment(this.ruleForm.tagUpdateTime[1]).format(
          "YYYY-MM-DD 00:00:00"
        ),
        createType: this.currentWay.wayName,
        tagType: this.queryType,
        id
      });
      this.$message({
        type: "success",
        message: "操作成功"
      });
      this.$emit("createSucc");
    },
    async checkToNextStep(step) {
      await this.$refs.ruleForm.validate();
      this.currentStep = step;
    },
    async queryTagAttrList() {
      let ruleType = undefined;
      if (this.queryType === "goods") {
        ruleType = "3";
      } else {
        ruleType = "1";
      }
      const { result } = await this.$store.dispatch("queryTagAttrList", {});
      console.log('result111',result)
      this.userAttrList = result.filter(v => v.ruleType === ruleType);
      this.userBehaviorList = result.filter(v => v.ruleType === "2");
      this.userGoodsAttr = result.filter(v => v.ruleType === "3");
      this.userGoodsAttr = this.userGoodsAttr.map(item => {
        item.allAList = item.ruleName == "商品品牌";
        item.allBList = item.ruleName == "微店分类";
        item.allCList = item.ruleName == "商品名称";
        item.allDList = item.ruleName == "商品条码";
        item.allEList = item.ruleName == "商品货号";
        item.allFList = item.ruleName == "商品价格";
        return item;
      });
      console.log("userGoodsAttr--222", this.userGoodsAttr);
    },
    // 转化汉字为拼音
    getPinyin() {
      let wordList = pinyin(this.ruleForm.tagName, {
        style: pinyin.STYLE_FIRST_LETTER
      });
      wordList = wordList.reduce((prev, cur) => prev.concat(cur), []);
      this.ruleForm.tagKey = wordList.join("");
    },
    // 进入步骤条下一步
    async toNext(i) {
      await this.$refs.ruleForm.validate();
      this.currentStep = i + 1 > 2 ? 2 : 1;
    },
    // 关闭抽屉
    closeDrawer() {
      this.currentStep = 1;
      this.$emit("closeDrawer");
    },
    showExample() {
      this.exampleDialogVisible = true;
    },
    index2Letter(i) {
      return String.fromCharCode(i + 65);
    },
    async testTags() {
      await this.$refs.ruleForm.validate();
      let actionName = "createTag";
      let id = undefined;
      if (this.tagDetails) {
        actionName = "queryTagtest";
        id = this.tagDetails.id;
      }
      if (this.currentWay.wayName !== "sql") {
        this.tagRunInfo.forEach(v => {
          v.rules.forEach(o => {
            o.rules.forEach(p => {
              if (p.userAttr) {
                p.keyMap = p.userAttr.ruleName;
                p.calcMode = p.userAttr.calcMode;
              }
            });
          });
        });
      }
      const { result } = await this.$store.dispatch(actionName, {
        ...this.ruleForm,
        tagCat: this.ruleForm.tagCatArray[0],
        tagKey: "pingtai_" + this.ruleForm.tagKey,
        tagRunInfo:
          this.currentWay.wayName === "sql"
            ? this.sql
            : JSON.stringify(this.tagRunInfo),
        tagUpdateStartTime: moment(this.ruleForm.tagUpdateTime[0]).format(
          "YYYY-MM-DD 00:00:00"
        ),
        tagUpdateEndTime: moment(this.ruleForm.tagUpdateTime[1]).format(
          "YYYY-MM-DD 00:00:00"
        ),
        createType: this.currentWay.wayName,
        tagType: this.queryType,
        id
      });
      if (result) {
        this.tagRunInfo.forEach((list, listIndex) => {
          list.rules.forEach((time, timeIndex) => {
            if (time.rules.length > 0) {
              // 表示有数据
              time.cations = true;
              time["timebute"] = time.rules[0].options.find(
                item => item.value === time.rules[0].symbol[0]
              ).label;
              time["Pregnant"] = time.rules[0].keyMap;
              if (time.rules[0].relativeDateType === "FUTURE") {
                time["terday"] = "未来";
              } else if (time.rules[0].relativeDateType === "PAST TIMES") {
                time["terday"] = "过去";
              }
            } else {
              time.cations = false;
            }
          });
        });
        let data = [];
        data = result.testInfo.forEach((item, index) => {
          item["formulas"] = this.tagRunInfo[index].rules;
        });

        this.catgorTestList = data;
        console.log(this.catgorTestList);
        console.log(785);
        this.testTagDialogVisible = true;
      }
    },
    remoteMethod(query) {
      if (query !== '') {
        this.storeCodeList = this.allMerchant.filter(v => v.storeName.indexOf(query) > -1);
      } else {
        this.storeCodeList = [];
      }
    },
    showTypeChange(val) {
      this.ruleForm.showType = val.toString();
      console.log("this.ruleForm.showType:",this.ruleForm.showType);
    },
  }
};
</script>

<style scoped lang="scss">
.drawer-wrapper {
  position: relative;
  height: 100vh;
  width: 1000px;
  box-sizing: border-box;
  .header {
    padding: 17px 30px;
    border-bottom: 1px solid #ddd;
    .title {
      font-weight: bold;
    }
  }
  .form-wrapper {
    border-top: 1px solid #ddd;
    padding: 30px 0 80px;
    margin: 0 20px;
    height: calc(100vh - 240px);
    overflow-y: auto;
  }
  .footer {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px 0;
    z-index: 1;
    background: #fff;
    box-shadow: 1px 5px 10px 5px rgba(0, 0, 0, 0.1);
  }
}

.example {
  .img-wrapper {
    margin: 20px auto;
    img {
      width: 100%;
    }
  }
}
.example-footer {
  margin-top: 20px;
}
.link {
  color: #0081e5;
  margin-left: 20px;
}

.tag-list {
  margin-top: 20px;
  .list-header {
    .tag {
      border-radius: 8px;
      border: 1px solid currentColor;
      padding: 0 14px;
      height: 32px;
      box-sizing: border-box;
      &.active {
        background: #e50163;
        color: #fff;
        .close {
          color: #fff;
        }
      }
    }
    .tag-name {
      margin-right: 25px;
      font-size: 14px;
    }
    .close {
      color: #ddd;
      font-size: 12px;
    }
  }

  .item-title {
    font-weight: bold;
    font-size: 16px;
  }

  @mixin border {
    border: 1px solid #eeeeee;
    padding: 20px;
    border-radius: 6px;
  }

  .list-row {
    @include border;
    margin-bottom: 20px;
  }

  .rule-list {
    @include border;
    margin-top: 20px;
  }

  .rule-item {
    @include border;
    margin-bottom: 20px;
    box-sizing: border-box;
    transition: all linear 0.2s;
    max-height: 100vh;
    &.collapse {
      overflow: hidden;
      max-height: 72px;
    }
    .item-header:not(:last-child) {
      margin-bottom: 20px;
    }
  }

  .rule-list {
    .child-condition {
      position: relative;
      margin-left: 20px;
      margin-top: 20px;
      .relation-wrapper {
        position: absolute;
        left: -12px;
        top: 0;
        bottom: 0;
      }
      .last-header {
        margin-left: 10px;
        &:not(:last-child) {
          margin-bottom: 10px;
        }
      }
    }
  }

  .relation-wrapper {
    position: relative;
    margin-right: 20px;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      bottom: 0;
      width: 1px;
      background: #d8d8d8;
    }
    .relation {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 16px;
      height: 16px;
      background: #f7f7f7;
      border-radius: 2px;
      border: 1px solid #dddddd;
      font-size: 12px;
      text-align: center;
      line-height: 16px;
      user-select: none;
    }
  }
  .collapse-wrapper {
    font-size: 12px;
    color: #ddd;
    margin-right: 8px;
  }

  .relative-between-time {
    font-size: 14px;
  }
}

.subrule-container {
  margin-left: 20px;
  .subrule-wrapper {
    position: relative;
    margin-left: 40px;
    .sub-rule:not(:last-child) {
      margin-bottom: 10px;
    }
  }
}

.newAdded {
  margin-left: 20px;
}

.index-wrapper {
  width: 18px;
  height: 18px;
  background: #0081e5;
  border-radius: 2px;
  text-align: center;
  line-height: 18px;
  margin-right: 6px;
  font-size: 13px;
  color: #fff;
  &.child {
    color: #0081e5;
    background: #e4f3ff;
    border: 1px solid currentColor;
    font-size: 12px;
  }
}

.m-size {
  font-size: 14px;
}
</style>
